/* eslint-disable no-dupe-keys */
export default {
  alarm_whitelist: {
    name: '报警白名单',
    // 属性（一般与对象内容匹配）
    prop: {
      charge_station: '充电站',
      charger: '充电桩',
      malfunction: '忽略故障',
      created_at: '创建时间',
      updated_at: '更新时间',
      alarm_category: '报警类型',
      ignored_count: '忽略次数',
      service_provider: '运营商',
      last_ignored_at: '最后忽略时间',
      internal_remark: '内部说明'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    // Enum的属性
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '输入充电站、桩编号',
      input_internal_remark: '备注说明(仅平台可见)'
    },
    titles: {
      base_info: '基本信息',
      malfunction: '忽略故障'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    current_alarm_whitelist: '当前订阅',
    tips: {
      whitelist: '添加白名单后，安全中心将不再提示该告警'
    }
  }
}
